import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { ReportEmailExcelCheckTask } from 'services/fund'
export default function useCheckTask(FinalMutate, task) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: string | undefined) => {
            return ReportEmailExcelCheckTask(payload)
        },
        onSuccess: (data, variable) => {
            FinalMutate(variable)
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })
    return { mutate }
}
